import { render } from "./NoDataRender.vue?vue&type=template&id=5bc04b98&ts=true"
import script from "./NoDataRender.vue?vue&type=script&lang=ts"
export * from "./NoDataRender.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__